import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { Gallery } from './components/Gallery';
import { Problem } from './components/Problem';
import { ProductReveal } from './components/ProductReveal';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { KitComparison } from './components/KitComparison';
import { MoreTestimonials } from './components/MoreTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Stats data-id="element-4" />
        <Testimonials data-id="element-5" />
        <Gallery data-id="element-6" />
        <Problem data-id="element-7" />
        <ProductReveal data-id="element-8" />
        <Bonuses data-id="element-9" />
        <Pricing data-id="element-10" />
        <KitComparison data-id="element-11" />
        <MoreTestimonials data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <CostOfInaction data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <PurchasePopup data-id="element-18" />
    </div>;
}